
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: 24,
      	filterTreeMobileStyle: 'style1'
	}
};

var boostPFSTemplate = {
  soldOutClass: "product--sold-out",
  saleClass: "product--in-sale",
  soldOutLabelHtml: "<div>" + boostPFSThemeConfig.label.sold_out + "</div>",
  saleLabelHtml: "<div>" + boostPFSThemeConfig.label.sale + "</div>",
  nameHtml:
    '<h4 class="product__name">' +
    "<span>{{itemNameLabel}}</span>" +
    '<span class="colour">{{itemColourLabel}}</span>' +
    "</h4>",
  vendorHtml: '<h3 class="product__vendor">{{itemVendorLabel}}</h3>',
  productTypeHtml: '<h5 class="product__type">{{itemProductTypeLabel}}</h5>',
  stickerHtml:
    '<div class= "product__sticker">' +
    '<span class="product__sticker-text">{{itemStickerLabel}}</span>' +
    "</div>",

  variantSizesHtml:
    '<label class="{{soldOutClass}}">' + "{{variantTitle}}" + "</label>",

  // Grid Template
  productGridItemHtml:
    '<div class="product product--item {{soldOutClass}} {{saleClass}}">' +
    '<a href="{{itemUrl}}#product" title="{{itemTitle}}" class="product__link" data-handle="{{itemHandle}}">' +
    "{{itemSticker}}" +
    '<div class="product__featured-image">' +
    '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
    "</div>" +
    '<div class="product__information">' +
    "{{itemProductType}}" +
    "{{itemVendor}}" +
    "{{itemName}}" +
    '<div class="product__prices">' +
    "{{itemPrice}}" +
    "</div>" +
    "</div>" +
    "</a>" +
    "</div>",

  // Pagination Template
  previousActiveHtml:
    '<span class="pagination__backward"><a href="{{itemUrl}}">Previous</a></span>',
  previousDisabledHtml:
    '<span class="pagination__backward disabled"><span>Previous</span></span>',
  nextActiveHtml:
    '<span class="pagination__forward"><a href="{{itemUrl}}">Next</a></span>',
  nextDisabledHtml:
    '<span class="pagination__forward disabled"><span>Next</span></span>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li class="active"><span>{{itemTitle}}</span></li>',
  pageItemRemainHtml: "<li><span>{{itemTitle}}</span></li>",
  pagePositionHtml: "{{current}} / {{total}}",
  paginateHtml:
    '<div class="pagination pagination--blog">{{previous}}<ul class="pagination__parts">{{pageItems}}</ul><span class="pagination__position">{{pagePosition}}</span>{{next}}</div>',

  // Sorting Template
  sortingHtml:
    '<label class="label--hidden">' +
    boostPFSThemeConfig.label.sorting +
    '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

(function () {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
      	var NOT_FOUND = -1;

        /** Support currencies **/
        var storeCurrency = 'GBP';
        var storeTaxRate = 1;
        var activeCurrency = Shopify.currency.active ?? storeCurrency;
        var currencyKey = activeCurrency.toLowerCase();

        /** In Store **/
        var inStoreOnly = data.tags.indexOf("meta:in-store-only") !== NOT_FOUND;

        /** Stickers **/
        function hasSticker(tag) {
          return tag.includes("meta:sticker:");
        }

        function stickerText(tags) {
          tag = tags.find(hasSticker);
          return tag === undefined ? "" : tag.replace(/meta\:sticker\:/, "");
        }

        var stickerLabel = inStoreOnly
        ? boostPFSThemeConfig.custom.in_store_only_sticker
        : stickerText(data.tags);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

      	// Add Thumbnail
        var itemThumbUrl =
          images.length > 0
            ? Utils.optimizeImage(images[0]["src"])
            : boostPFSConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

        /** Calculate Display Prices */
        var itemPriceHtml = "";
        var priceMin = 0;
        var compareAtPriceMin = 0;

        if (data['price_min_' + currencyKey] != undefined) {
          priceMin = data['price_min_' + currencyKey] * 100;
        }

        if (data['compare_at_price_min_' + currencyKey] != undefined) {
          compareAtPriceMin = data['compare_at_price_min_' + currencyKey] * 100;
        }

        var taxMultiplier = storeTaxRate;

        if (activeCurrency !== storeCurrency || data.product_type === "Gift Card") {
          taxMultiplier = 1;
        }

        displayPriceMin = Utils.formatMoney((priceMin * taxMultiplier) / 100);
        displayCompareAtPriceMin = Utils.formatMoney((compareAtPriceMin * taxMultiplier) / 100);

        if (data.title != "" && !inStoreOnly) {
          itemPriceHtml += '<div class="price">';
          if (onSale) {
            itemPriceHtml +=
              '<span class="price__original">' +
              displayCompareAtPriceMin +
              "</span> ";
            itemPriceHtml +=
              '<span class="price__sale">' +
              displayPriceMin +
              "</span> ";
          } else {
            itemPriceHtml +=
              '<span class="price__full">' +
              displayPriceMin +
              "</span> ";
          }
          itemPriceHtml += "</div>";
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add soldOut class
        var soldOutClass =
          soldOut && !inStoreOnly ? boostPFSTemplate.soldOutClass : "";
        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

        // Add onSale class
        var saleClass = onSale && !inStoreOnly ? boostPFSTemplate.saleClass : "";
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

        // Add soldOut Label
        var itemSoldOutLabelHtml =
          soldOut && !inStoreOnly ? boostPFSTemplate.soldOutLabelHtml : "";
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

        // Add onSale Label
        var itemSaleLabelHtml =
          onSale && !inStoreOnly ? boostPFSTemplate.saleLabelHtml : "";
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

        // Add Name
        var dataNoColour = data.title.match(/.+?(?=\s\()/) ?  data.title.match(/.+?(?=\s\()/)[0] : data.title;
        var dataName = dataNoColour.replace(data.vendor, "");
        var dataColour = data.title.match(/.+?(?=\s\()/) ? data.title.match(/\(([^)]+)\)/)[1] : data.title;
        var itemNameHtml = boostPFSTemplate.nameHtml.replace(
          /{{itemNameLabel}}/g,
          dataName
        );
        var itemNameHtml = itemNameHtml.replace(/{{itemColourLabel}}/g, dataColour);
        itemHtml = itemHtml.replace(/{{itemName}}/g, itemNameHtml);

        // Add Vendor
        var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable
          ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
          : "";
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

        // Add Type
        var itemProductTypeHtml = boostPFSThemeConfig.custom.productType_enable
          ? boostPFSTemplate.productTypeHtml.replace(
              /{{itemProductTypeLabel}}/g,
              data.product_type
            )
          : "";
        itemHtml = itemHtml.replace(/{{itemProductType}}/g, itemProductTypeHtml);

        // Add Sticker
        var itemStickerHtml = stickerLabel
          ? boostPFSTemplate.stickerHtml.replace(
              /{{itemStickerLabel}}/g,
              stickerLabel
            )
          : "";
        itemHtml = itemHtml.replace(/{{itemSticker}}/g, itemStickerHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR && boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
	};

	// Build additional elements
	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

	};

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function (a, b) {
	}
})();
